import { GrDomain } from "react-icons/gr";
import { createDocsUrl } from "../../utils/urls";

const PageEditSidebar: React.FC<any> = ({ site, page }) => {
  const rooted = createDocsUrl(site);

  const url = page.published
    ? `${rooted}/${page.slug}`
    : `${rooted}/${page.slug}?preview=${site.preview_token}`;

  return (
    <div className="h-screen p-5 text-white">
      Page Status: <strong>{page.published ? "Published" : "Draft"}</strong>
      <div className="my-4 items-center">
        <p className="mr-2 font-medium flex items-center">
          <GrDomain className="mr-2 text-primary-dark" />{" "}
          {page.published ? "View Page" : "Preview"}:
        </p>{" "}
        <a
          href={`https://${url}`}
          target="_blank"
          rel="noreferrer"
          className="block my-1 font-medium text-primary truncate"
        >
          {url}
        </a>
      </div>
    </div>
  );
};

export default PageEditSidebar;
